/**
 * Scroll tools.
 */
H_Tools.scroll_tools = (() => {
    let throttleTimeout;
    let throttleDelay = 100;

    /**
     * Throttle function to limit the scroll event frequency.
     */
    function throttle(callback) {
        if (!throttleTimeout) {
            throttleTimeout = setTimeout(function () {
                callback();
                throttleTimeout = null;
            }, throttleDelay);
        }
    }

    function onScroll() {
        const currentScrollTop =
            window.scrollY || document.documentElement.scrollTop;

        H_Tools.scroll_tools.isScrollingDown =
            currentScrollTop > H_Tools.scroll_tools.lastScrollTop;

        // Update the last scroll position
        H_Tools.scroll_tools.lastScrollTop = currentScrollTop;
    }

    window.addEventListener('scroll', () => {
        throttle(onScroll);
        // onScroll();
    });

    // Return an object to expose variables
    return {
        isScrollingDown: false,
        lastScrollTop: 0,
    };
})();
